export enum ARBITRAGE_STATUS {
  WAITING_CLIENT_VALIDATION = 'En attente validation client',
}
